//TODO после полного перехода на vue добавить страницу с обработкой 130 ошибки
//компонент на new-licexpert blackListError.vue нужно будет сделать аналогичный

import axios from 'axios'
import { set } from 'lodash'
import searchStateModule from './components/search/searchStateModule'
import cardStore from './components/card/cardStore'
import monitoringModule from './components/monitoring/monitoringStore'
import flCheckStore from './components/rosseti/visitorFLCheckCombined/flCheck/flCheckStore'
import relationsStore from './components/global/RelationsSearch/relationsSearchStore.js'
import addressCheckStore from './components/rosseti/visitorFLCheckCombined/addressCheck/addressCheckStore.js'
//@ts-ignore
import { htmlStringToPrint, translit, Base64, downloadBinaryFile, downloadByUrl  } from './helpers.ts'
import userModule from './modules/userModule.js'

declare global {
    interface Window {
        apiSession: String;
        api_pro: String;
        api: String;
        auth: any;
        apiUser: any;
        userName: any;
        userGroups: any;
    }
    interface Process {
        api: any;
        env: any;
    }
}

declare var process: Process

const dadataModule = {
    namespaced: true,
    state:{
        token: "c7e6720adc39e28edd06107e1d23e45fb6c27f8e",
    },
    actions: {
        getAddress({getters}, payload){
            return getters.axios('address', payload)
        },
        getSuggestions({getters}, payload){
            return getters.axios('party', payload)
        }
    },
    getters: {
        api: ({ token }) => (action, query, count) => {
            return axios({
                baseURL: `https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/${action}`,
                method: 'post',
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: `Token ${token}`
                },
                data: {
                    query,
                    count
                }
            }).then(e => e.data)
        }
    }
}

const romAuthModule = {
    actions: {
        RomAPI({ dispatch }, { method, data, id, out_format, responseType = 'json' }) {
            return axios({
                responseType,
                baseURL: `${process.env.API}?${method}`,
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                data: {
                    auth: {
                        // @ts-ignore
                        sid: window.apiSession,
                        // @ts-ignore
                        cid: window.cid === '0' ? null : window.cid,
                        // demo: false
                    },
                    id,
                    method,
                    data,
                    out_format
                }
            }).then(res => {

                const methodNames = {
                    additional_verification: "Дополнительная проверка",
                    fed_rozysk: "Федеральный розыск",
                    terrorists: "Реестр террористов / экстремистов",
                    passports: "Реестр недействительных паспортов",
                    fssp_fl: "ФССП",
                    check_fl: "Проверка посетителя",
                    verification_fl:"Проверка ФЛ"
                }

                const viewMethod = methodNames[method] ? methodNames[method] : method
                if(res.data && res.data.code) {
                    switch(res.data.code) {
                        case 100:
                        case 163:
                        case 164:
                            dispatch("showErrorPopUp", "внутренняя ошибка сервера")
                            break;
                        case 101:
                            dispatch("showErrorPopUp", "неизвестное приложение")
                            break;
                        case 102:
                        case 103: 
                        case 152: 
                        case 160: 
                        case 161: 
                        case 162:
                            dispatch("showErrorPopUp", "ошибка БД")
                            break;
                        case 104:
                            dispatch("showErrorPopUp", "неверный маршрут")
                            break;
                        case 105:
                        case 153: 
                        case 155:
                            dispatch("showErrorPopUp", `${viewMethod}, неверный параметр`)
                            break;
                        case 106:
                            switch(res.data.auth.code){
                                case - 1:
                                    dispatch("showErrorPopUp", "неизвестная ошибка")
                                    break;
                                case 1:
                                    dispatch("showErrorPopUp", "Ошибка авторизации. Код: 1")
                                    break;
                                case 2:
                                    dispatch("showErrorPopUp", "Ошибка авторизации. Код: 2")
                                    break;
                                case 3:
                                    dispatch("showErrorPopUp", "неверный пароль")
                                    break;
                                case 4:
                                    dispatch("showErrorPopUp", "неверный пароль")
                                    break;
                                case 5:
                                    dispatch("showErrorPopUp", "доступ запрещён")
                                    break;
                                case 6:
                                    dispatch("showErrorPopUp", "превышен лимит сессий")
                                    break;
                                case 7:
                                    // dispatch("showErrorPopUp", "Ваш сеанс был завершён. Авторизуйтесь.")
                                    break;
                                case 8:
                                    dispatch("showErrorPopUp", "Ошибка авторизации. Код: 8")
                                    break;
                                case 9:
                                    dispatch("showErrorPopUp", "превышен лимит запросов")
                                    break;
                                case 10:
                                    dispatch("showErrorPopUp", "Ошибка авторизации. Код: 10")
                                    break;
                                case 11:
                                    dispatch("showErrorPopUp", "Ошибка авторизации. Код: 11")
                                    break;
                                case 12:
                                    dispatch("showErrorPopUp", "Ошибка авторизации. Код: 12")
                                    break;
                                case 13:
                                    dispatch("showErrorPopUp", "Ошибка авторизации. Код: 13")
                                    break;
                                case 14:
                                    dispatch("showErrorPopUp", "Ошибка авторизации. Код: 14")
                                    break;
                                case 15:
                                    dispatch("showErrorPopUp", "отсутствует действующая подписка")
                                    break;
                                case 16:
                                    dispatch("showErrorPopUp", "Ошибка авторизации. Код: 16")
                                    break;
                                case 17:
                                    dispatch("showErrorPopUp", "Ошибка авторизации. Код: 17")
                                    break;
                                case 18:
                                    dispatch("showErrorPopUp", "Ошибка авторизации. Код: 18")
                                    break;
                                case 19:
                                    dispatch("showErrorPopUp", "Ошибка авторизации. Код: 19")
                                    break;
                                case 20:
                                    dispatch("showErrorPopUp", "Ошибка авторизации. Код: 20")
                                    break;
                                case 21:
                                    dispatch("showErrorPopUp", "Ошибка авторизации. Код: 21")
                                    break;
                                case 22:
                                    dispatch("showErrorPopUp", "Ошибка авторизации. Код: 22")
                                    break;
                                case 23:
                                    dispatch("showErrorPopUp", "Ошибка авторизации. Код: 23")
                                    break;
                            }
                            break;
                        case 107:
                            dispatch("showErrorPopUp", "ошибка HTTP")
                            break;
                        case 108:
                            dispatch("showErrorPopUp", "неизвестный метод")
                            break;
                        case 109:
                            dispatch("showErrorPopUp", "ошибка внешнего модуля")
                            break;
                        case 110:
                            dispatch("showErrorPopUp", "метод отключен")
                            break;
                        case 111:
                        case 151:
                            dispatch("showErrorPopUp", "ошибка конфигурации")
                            break;
                        case 112:
                            dispatch("showErrorPopUp", "заняты все сессии БД")
                            break;
                        case 113:
                            dispatch("showErrorPopUp", "ошибка конвертации")
                            break;
                        case 114:
                            dispatch("showErrorPopUp", "файл не найден")
                            break;
                        case 115:
                            dispatch("showErrorPopUp", "ошибка входных данных")
                            break;
                        case 116:
                            dispatch("showErrorPopUp", "ошибка формирования КО")
                            break;
                        case 117:
                            dispatch("showErrorPopUp", "сервис недоступен")
                            break;
                        case 118:
                            dispatch("showErrorPopUp", "ошибка JSON")
                            break;
                        case 119: 
                        case 156:
                            dispatch("showErrorPopUp", "доступ запрещён")
                            break;
                        case 120:
                            dispatch("showErrorPopUp", "неподдерживаемый метод")
                            break;
                        case 121:
                            dispatch("showErrorPopUp", "пользователь не найден")
                            break;
                        case 150:
                            dispatch("showErrorPopUp", "неверный ID")
                            break;
                        case 154:
                            dispatch("showErrorPopUp", "модуль работает в демо режиме")
                            break;
                        case 165:
                            dispatch("showErrorPopUp", "время ожидания истекло")
                            break;
                        case 170:
                            dispatch("showErrorPopUp", "ошибка загрузки файла")
                            break;
                        case 0:
                            return res

                    }
                }

                return res
            }).catch(err => {
                if(!err.status) {
                    dispatch('showErrorPopUp', "Ошибка API")
                }
            })
        }
    }
}

const paginatorModule = {
    namespaced: true,
    state: {
        isPaginatorHidden: false
    },
    mutations: {
        changePaginatorState(state, value) {
            state.isPaginatorHidden = value
        }
    },
    actions: {
        setPaginatorState({ commit }, value) {
            commit('changePaginatorState', value)
        }
    }
}

const v3Module = {
    namespaced: true,
    name: 'v3',
    state: {
        downloadURL: process.env.API_DOWNLOAD
    },
    actions: {
        API({ dispatch }, { method, data, reqOpts, isRecursion }) {
            return axios({
                //@ts-ignore
                baseURL: `${process.env.API}?${method}`,
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                ...reqOpts,
                data: {
                    auth: {
                        sid: window.apiSession,
                        //@ts-ignore
                        cid: window.cid,
                        demo: false
                    },
                    method,
                    data
                }
            }).then( async res => {
                switch(res?.data?.code) {
                    case 105:
                        dispatch('showErrorPopUp', `Введены неверные параметры ${method}`, { root: true })
                        break
                    case 101:
                        dispatch('showErrorPopUp', `Неизвестная ошибка API ${method}`, { root: true })
                        break
                    case 18:
                        await dispatch('card/getCID')
                        if(isRecursion !== true) { dispatch('API', { method, data, reqOpts, isRecursion: true }) }
                        break
                    default:
                        return res
                }
            }).catch(err => {
                if(!err.status) {
                    dispatch('showErrorPopUp', `Неизвестная ошибка ${method}`, { root: true })
                }
            })
        }
    }
}

const transitionModule = {
    namespaced: true,
    state: {
        isLeftLeaved: false,
        isRigthLeaved: true
    },
    actions: {
        changeLeft({ commit }, value) {
            commit('setStateObject', { name: 'transition.isLeftLeaved', value }, { root: true })
        },
        changeRight({ commit }, value) {
            commit('setStateObject', { name: 'transition.isRigthLeaved', value }, { root: true })
        }
    }
}

const globalStore = {
    state: {
        desktopResolution: 960,
        title: "Лик:Эксперт",
        axios: {
            headers: {
                // @ts-ignore
                "Authorization": "Bearer " + window.apiSession,
                // @ts-ignore
                "Cid" : window.cid
            }
        },
        // @ts-ignore
        auth: window.auth,
        // @ts-ignore
        apiUser: window.apiUser,
        // @ts-ignore
        userName: window.userName,
        // @ts-ignore
        apiSession: window.apiSession,
        news: {
            data: [],
            total: null,
            status: false
        },
        specialPriviliges: {
            employeeCount: [
                "TechAviaM_LE",
                "TechnoAvia_LE",
                "Profile12",
                "Program018",
                "rvv2016",
                "YugoPolis",
                "program017",
                "visor1",
                "visor2",
                "visor3",
                "visor4",
                "visor5",
                "Starikov_LE"
            ].map(e => e.toLowerCase())
        },
        modals: {
            monitoring: false,
            passportCheck: false,
            flatCheck: false
        }
    },
    mutations: {
        setStateObject(state: any, stateObject) {
            set(state, stateObject.name, stateObject.value)
        },
        switchModals(state: any, objectNameToSwitch) {
            Object.keys(state.modals).forEach(e => { state.modals[e] = false })
            state.modals[objectNameToSwitch] = !state.modals[objectNameToSwitch]
            console.log('switchModals', state.modals)
        }
    },
    actions: {
        async init({ dispatch }) {
            await dispatch('getUserInfo')
            await dispatch('monitoring/getCompanies')
            await dispatch('monitoring/getAllCompanies')
        },
        downloadFile(_, { url }) {
            downloadByUrl(url)
        },
        showErrorPopUp(_, payload) {
            UIkit.notify(payload, {
                pos: 'top-center',
                status: 'danger',
                timeout: 4000
            })
        },
        showSuccessPopUp(_, payload){
            UIkit.notify(payload, {
                pos: 'top-center',
                status: 'success',
                timeout: 4000
            })
        },  
        downloadPDF({ dispatch, state }, { html, title, filename, target, style }) {
            
            const htmlCode = htmlStringToPrint(title, html, `${style} canvas {display: none !important;} table {border-collapse: collapse; width: 100%;} #print-pdf-hint { display: none } .no_print {display: none !important} .no_print-pre {white-space: pre-line;} .bold__date{font-weight: bold;} td, th{padding: 10px 0; text-align: center; border-width: 1px; border-style: solid;border-collapse: collapse; border-color: #777778;} .fa-check, .print-green{color: #27ae60;} .fa-times{color: #e74c3c;} .print-red {text-decoration: line-through; color: #e74c3c;} .print-table{width: 100%;} .print-image{max-width: 100px} .tax__table_green{color: #3cc274;} .tax__table_red{color: #D24135;} .sro__item_inactive {color: #D24135;} .sro__item_active{color: #3cc274;}` )
            const currentFilename = filename || `${translit(title)}.pdf`
    
            return dispatch('v3/API', {
                method: 'save_file',
                data: {
                    save_to_history: false, 
                    source: process.env.PRODUCT_CODE,
                    format: 'pdf',
                    landspace: false,
                    target,
                    out_name: currentFilename,
                    ogrn: parseInt(state.card.company.ogrn),
                    html: Base64.encode(htmlCode)
                },
                reqOpts: {
                    responseType: 'arraybuffer'
                }
            }, { root: true }).then(res => {
                if(res?.status === 200) {
                    downloadBinaryFile(res.data, currentFilename)
                } else {
                    dispatch('showErrorPopUp', 'Во время загрузки файла произошла ошибка.', { root: true })
                }
            }).catch(err => {
                console.error(err.message)
            })
        },

        printHTML({ dispatch }, { html, title, style }) {

            if(!html) {
                dispatch('showErrorPopUp', 'При печати произошла ошибка')
                console.error('Передан пустой HTML документ')
            } else {
                const htmlCode = htmlStringToPrint(title, html, `${style} canvas {display: none !important;} table {border-collapse: collapse; width: 100%;} #print-pdf-hint { display: none } .no_print {display: none !important} .no_print-pre {white-space: pre-line;} .bold__date{font-weight: bold;} td, th{padding: 10px 0; text-align: center; border-width: 1px; border-style: solid;border-collapse: collapse; border-color: #777778;} .fa-check, .print-green{color: #27ae60;} .fa-times{color: #e74c3c;} .print-red {text-decoration: line-through; color: #e74c3c;} .print-table{width: 100%;} .print-image{max-width: 100px} .tax__table_green{color: #3cc274;} .tax__table_red{color: #D24135;} .sro__item_inactive {color: #D24135;} .sro__item_active{color: #3cc274;}` )
                const printWin = window.open();
                printWin.document.write(htmlCode);
                printWin.document.close();
            }
            
        }
    },
    modules: {
        search: searchStateModule,
        card: cardStore,
        dadata: dadataModule,
        romAuth: romAuthModule,
        monitoring: monitoringModule,
        user: userModule,
        flCheck: flCheckStore,
        relations: relationsStore,
        paginator: paginatorModule,
        addressCheck: addressCheckStore,
        v3: v3Module,
        transition: transitionModule
    },
}

export default globalStore